export default () => {
	const featuresArray = document.querySelectorAll('.features') as NodeListOf<HTMLElement>

	featuresArray?.forEach(features => {
		const tabs = features.querySelectorAll('.block__tabs > span') as NodeListOf<HTMLSpanElement>
		const contents = features.querySelectorAll('.block__content > .items') as NodeListOf<HTMLDivElement>
		tabs?.forEach((tab, index) => {
			tab.onclick = () => {
				tabs.forEach(items => items.classList.remove('active'))
				contents?.forEach(items => items.classList.remove('active'))
				tab.classList.add('active')
				contents[index]?.classList.add('active')
			}
		})
	})
}
